import { css, CSSProperties } from 'styled-components'

export type TTableMixin = Pick<CSSProperties, 'tableLayout'>

export const TableMixin = ({ tableLayout }: TTableMixin) => css`
  table-layout: ${tableLayout || ''};
`
